import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useRole } from "./useRole";

/**
 * Componente para proteger rutas por rol
 * @param {string|string[]} requiredRoles - Rol(s) requerido(s) para acceder
 * @param {React.ReactNode} fallback - Componente a mostrar si no tiene acceso (default: página acceso denegado)
 */
export default function RequireRole({ requiredRoles, fallback }) {
  const { bootstrapping } = useAuth();
  const { hasAnyRole, hasAccessToSection, SECTIONS } = useRole();

  if (bootstrapping) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  // Convertir a array si es string
  const rolesArray = Array.isArray(requiredRoles)
    ? requiredRoles
    : [requiredRoles];

  // Verificar si usuario cumple requisitos
  const hasAccess =
    rolesArray.length === 0 || hasAnyRole(rolesArray);

  if (!hasAccess) {
    if (fallback) return fallback;

    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Access Denied
          </h1>
          <p className="text-lg text-gray-600 mb-8">
            You do not have permission to access this section.
          </p>
          <a
            href="/"
            className="inline-block px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Back to home
          </a>
        </div>
      </div>
    );
  }

  return <Outlet />;
}
